import { type AxiosInstance } from "axios";
import type { EditNameFormData, Design } from "@/features/dmManagement/types";
import { handleMutationError } from "@/features/dmManagement/api/handleApiError";

/**
 * 指定されたデザインのタスク名を更新する。
 * @param apiClient - axios インスタンス
 * @param id - デザインID
 * @param data - 更新するタスク名データ
 * @returns 更新後のデザイン情報
 */
export const PutDesignNameAPI = async (
  apiClient: AxiosInstance,
  id: number,
  data: EditNameFormData
): Promise<Design> => {
  const url = `/dm/designs/${id}/`;

  try {
    const response = await apiClient.put<Design>(url, data);
    return response.data;
  } catch (error) {
    return handleMutationError(error);
  }
};
